export default "__VITE_ASSET__fa5b3ebc__"